import { GenericSaleProcessDto } from "@/api/sale-process/generic";
import { genericSaleProcessInitialState, GenericSaleProcessState } from "./genericSaleProcess";
import { GENERIC_SALE_PROCESS_CLEAR_STATE, GENERIC_SALE_PROCESS_SET_PROCESS } from "./constants";

const clear = (state: GenericSaleProcessState) => {
	Object.assign(state, genericSaleProcessInitialState());
};

const setProcess = (state: GenericSaleProcessState, payload: GenericSaleProcessDto) => {
	const { id, status, coverage, customer, business, billing, selectedBundle, shoppingCartId, notes, digitelCircuitType } = payload;

	state.id = id;
	state.status = status;
	state.selectedBundle = selectedBundle;
	state.shoppingCartId = shoppingCartId;

	state.notes = notes;
	state.digitelCircuitType = digitelCircuitType;

	state.coverage = coverage;
	state.customer = customer;
	state.business = business;
	state.billing = billing;
};

export default {
	[GENERIC_SALE_PROCESS_CLEAR_STATE]: clear,
	[GENERIC_SALE_PROCESS_SET_PROCESS]: setProcess
};
